// ─────────────────────────────────────────────────────────────────────────────
// Mobile Number Numerology — Combination Analysis
// Each pair is stored under both orders (e.g. "14" and "41" → same combo)
// ─────────────────────────────────────────────────────────────────────────────

export const MOBILE_COMBINATIONS = {
    // ══ NEGATIVE ════════════════════════════════════════════════════════════════
    '14': { type: 'negative', pair: '14 / 41', meaning: 'Person can get attracted to Loan liabilities, Legal Notice, Health issues' },
    '41': { type: 'negative', pair: '14 / 41', meaning: 'Person can get attracted to Loan liabilities, Legal Notice, Health issues' },

    '16': { type: 'negative', pair: '16 / 61', label: 'Most Negative', meaning: 'Spouse health issues, married life issues, income confined — Owners have less income at the time of having this mobile number.' },
    '61': { type: 'negative', pair: '16 / 61', label: 'Most Negative', meaning: 'Spouse health issues, married life issues, income confined — Owners have less income at the time of having this mobile number.' },

    '18': { type: 'negative', pair: '18 / 81', label: 'Very Negative', meaning: 'Spouse health issue, understanding issues in father & son, Govt. related issue, change in job frequently.' },
    '81': { type: 'negative', pair: '18 / 81', label: 'Very Negative', meaning: 'Spouse health issue, understanding issues in father & son, Govt. related issue, change in job frequently.' },

    '23': { type: 'negative', pair: '23 / 32', meaning: 'Enemy will not be able to harm the native' },
    '32': { type: 'negative', pair: '23 / 32', meaning: 'Enemy will not be able to harm the native' },

    '26': { type: 'negative', pair: '26 / 62', meaning: 'Barrier in Studies or Break in education, Girl-Problem with mother in law, Attraction towards money or opposite sex, Chances of less Sperm count or Diabetes.' },
    '62': { type: 'negative', pair: '26 / 62', meaning: 'Barrier in Studies or Break in education, Girl-Problem with mother in law, Attraction towards money or opposite sex, Chances of less Sperm count or Diabetes.' },

    '27': { type: 'negative', pair: '27 / 72', meaning: 'Good intuition, Joint pain Or Urine related disease, Arthritis (Vaat Issue)' },
    '72': { type: 'negative', pair: '27 / 72', meaning: 'Good intuition, Joint pain Or Urine related disease, Arthritis (Vaat Issue)' },

    '28': { type: 'negative', pair: '28 / 82', meaning: 'Excessive Medical/Hospital Expenditure, 2 marriages in the Family, Vish yog' },
    '82': { type: 'negative', pair: '28 / 82', meaning: 'Excessive Medical/Hospital Expenditure, 2 marriages in the Family, Vish yog' },

    '34': { type: 'negative', pair: '34 / 43', meaning: 'Legs shivering, Paralysis to someone in the family, Breathing related issues to person' },
    '43': { type: 'negative', pair: '34 / 43', meaning: 'Legs shivering, Paralysis to someone in the family, Breathing related issues to person' },

    '45': { type: 'negative', pair: '45 / 54', meaning: 'Needs to visit Hospital visits for different medical reasons and Court for different issues.' },
    '54': { type: 'negative', pair: '45 / 54', meaning: 'Needs to visit Hospital visits for different medical reasons and Court for different issues.' },

    '46': { type: 'negative', pair: '46 / 64', meaning: 'Multiple relationship, Inter-cast marriage, UT infection, Extra marital affair' },
    '64': { type: 'negative', pair: '46 / 64', meaning: 'Multiple relationship, Inter-cast marriage, UT infection, Extra marital affair' },

    '48': { type: 'negative', pair: '48 / 84', label: 'Very Negative', meaning: 'Blood related disease, Incurable problems, Accident yog' },
    '84': { type: 'negative', pair: '48 / 84', label: 'Very Negative', meaning: 'Blood related disease, Incurable problems, Accident yog' },

    '67': { type: 'negative', pair: '67 / 76', meaning: 'Chances of Love marriage, Issue in Spouse health, Chances of disturbed married life' },
    '76': { type: 'negative', pair: '67 / 76', meaning: 'Chances of Love marriage, Issue in Spouse health, Chances of disturbed married life' },

    '68': { type: 'negative', pair: '68 / 86', meaning: 'Eye Problem, Issue in any one organ of Body' },
    '86': { type: 'negative', pair: '68 / 86', meaning: 'Eye Problem, Issue in any one organ of Body' },

    '89': { type: 'negative', pair: '89 / 98', meaning: 'Argumentative, Works with Principle, Person might get chronic issue in later part of life.' },
    '98': { type: 'negative', pair: '89 / 98', meaning: 'Argumentative, Works with Principle, Person might get chronic issue in later part of life.' },

    '17': { type: 'negative', pair: '17 / 71', meaning: 'Chances of 2 Marriage , Dhoka, Major relationship issues' },
    '71': { type: 'negative', pair: '17 / 71', meaning: 'Chances of 2 Marriage , Dhoka, Major relationship issues' },

    '24': { type: 'negative', pair: '24 / 42', meaning: 'Keep patience to achieve something, Makes different plans and brain actively processing those plans, negative/destructive thinking' },
    '42': { type: 'negative', pair: '24 / 42', meaning: 'Keep patience to achieve something, Makes different plans and brain actively processing those plans, negative/destructive thinking' },

    '36': { type: 'negative', pair: '36 / 63', meaning: 'More of Principal oriented person, Barrier in Studies, Good knowledge but native will struggle in presentation.' },
    '63': { type: 'negative', pair: '36 / 63', meaning: 'More of Principal oriented person, Barrier in Studies, Good knowledge but native will struggle in presentation.' },

    '49': { type: 'negative', pair: '49 / 94', meaning: 'Do risky work, Criminal minded' },
    '94': { type: 'negative', pair: '49 / 94', meaning: 'Do risky work, Criminal minded' },

    '58': { type: 'negative', pair: '58 / 85', meaning: 'Money stuck , Calculated mind, Money loss' },
    '85': { type: 'negative', pair: '58 / 85', meaning: 'Money stuck , Calculated mind, Money loss' },

    '79': { type: 'negative', pair: '79 / 97', meaning: 'Separation from Father' },
    '97': { type: 'negative', pair: '79 / 97', meaning: 'Separation from Father' },

    // ══ POSITIVE ════════════════════════════════════════════════════════════════
    '13': { type: 'positive', pair: '13 / 31', meaning: 'Good Advisor, Good Education, Respectful and Popular, makes person Professional' },
    '31': { type: 'positive', pair: '13 / 31', meaning: 'Good Advisor, Good Education, Respectful and Popular, makes person Professional' },

    '12': { type: 'positive', pair: '12 / 21', meaning: 'Attractive face, person has savings, Helpful life partner' },
    '21': { type: 'positive', pair: '12 / 21', meaning: 'Attractive face, person has savings, Helpful life partner' },

    '19': { type: 'positive', pair: '19 / 91', meaning: 'You own what u want, Always on a high place, Professional person' },
    '91': { type: 'positive', pair: '19 / 91', meaning: 'You own what u want, Always on a high place, Professional person' },

    '35': { type: 'positive', pair: '35 / 53', meaning: 'Native gets success Successful, Good Economical Condition' },
    '53': { type: 'positive', pair: '35 / 53', meaning: 'Native gets success Successful, Good Economical Condition' },

    '56': { type: 'positive', pair: '56 / 65', meaning: 'Business Minded, Earns money & Luxury both' },
    '65': { type: 'positive', pair: '56 / 65', meaning: 'Business Minded, Earns money & Luxury both' },

    '59': { type: 'positive', pair: '59 / 95', meaning: 'Person opts for Science or Commerce stream.' },
    '95': { type: 'positive', pair: '59 / 95', meaning: 'Person opts for Science or Commerce stream.' },

    '39': { type: 'positive', pair: '39 / 93', meaning: 'Loves to share knowledge.' },
    '93': { type: 'positive', pair: '39 / 93', meaning: 'Loves to share knowledge.' },

    '15': { type: 'positive', pair: '15 / 51', meaning: "Father's popularity, Generally these people make their father famous (good cause)" },
    '51': { type: 'positive', pair: '15 / 51', meaning: "Father's popularity, Generally these people make their father famous (good cause)" },

    '25': { type: 'positive', pair: '25 / 52', meaning: 'Hath me Shaffa, Work in occult science/Medical line, Gives support/guidance to others,' },
    '52': { type: 'positive', pair: '25 / 52', meaning: 'Hath me Shaffa, Work in occult science/Medical line, Gives support/guidance to others,' },

    '29': { type: 'positive', pair: '29 / 92', meaning: 'Person have good amount of Money, Laxmi Yog' },
    '92': { type: 'positive', pair: '29 / 92', meaning: 'Person have good amount of Money, Laxmi Yog' },

    '69': { type: 'positive', pair: '69 / 96', meaning: 'Good management skill, Good Planner' },
    '96': { type: 'positive', pair: '69 / 96', meaning: 'Good management skill, Good Planner' },

    // ══ NEUTRAL (Positive + Negative both) ══════════════════════════════════════
    '37': { type: 'neutral', pair: '37 / 73', meaning: 'Complete personality, person would be able to take benefit from knowledge.' },
    '73': { type: 'neutral', pair: '37 / 73', meaning: 'Complete personality, person would be able to take benefit from knowledge.' },

    '38': { type: 'neutral', pair: '38 / 83', meaning: 'Real Estate, Counsellor, Peacemaker or mediator between Two parties.' },
    '83': { type: 'neutral', pair: '38 / 83', meaning: 'Real Estate, Counsellor, Peacemaker or mediator between Two parties.' },

    '47': { type: 'neutral', pair: '47 / 74', meaning: 'Honest, Brilliant, gives importance of Integrity, Rahu-Ketu Combo.' },
    '74': { type: 'neutral', pair: '47 / 74', meaning: 'Honest, Brilliant, gives importance of Integrity, Rahu-Ketu Combo.' },

    '57': { type: 'neutral', pair: '57 / 75', meaning: 'Speaker, writer, Public relation, Good Expressive person, Lot of persons come to them for Advice.' },
    '75': { type: 'neutral', pair: '57 / 75', meaning: 'Speaker, writer, Public relation, Good Expressive person, Lot of persons come to them for Advice.' },

    '78': { type: 'neutral', pair: '78 / 87', meaning: 'Healer, Idealistic, Solve any problem by own power.' },
    '87': { type: 'neutral', pair: '78 / 87', meaning: 'Healer, Idealistic, Solve any problem by own power.' },

    // ══ REPEATED DIGIT PATTERNS ══════════════════════════════════════════════════
    // ── Double ───────────────────────────────────────────────────────────────────
    '11': { type: 'positive', pair: '11', label: 'Repeated 1s', meaning: 'Strong Leadership qualities' },
    '22': { type: 'positive', pair: '22', label: 'Repeated 2s', meaning: 'Helpful & Cooperative' },
    '33': { type: 'positive', pair: '33', label: 'Repeated 3s', meaning: 'Blessings of Guru or teacher' },
    '44': { type: 'negative', pair: '44', label: 'Repeated 4s', meaning: 'Should be avoided at all cost. Dangerous combination' },
    '55': { type: 'positive', pair: '55', label: 'Repeated 5s', meaning: 'Very clever & Intelligent' },
    '66': { type: 'positive', pair: '66', label: 'Repeated 6s', meaning: 'Luxuries in life , Good relationships' },
    '77': { type: 'negative', pair: '77', label: 'Repeated 7s', meaning: 'Depression, Lonliness' },
    '88': { type: 'negative', pair: '88', label: 'Repeated 8s', meaning: 'Life is full of struggles' },
    '99': { type: 'positive', pair: '99', label: 'Repeated 9s', meaning: 'Good, High on energy' },

    // ── Triple ────────────────────────────────────────────────────────────────────
    '111': { type: 'negative', pair: '111', label: 'Triple 1s', meaning: 'Arrogant, Egoistic and Stubborn' },
    '222': { type: 'negative', pair: '222', label: 'Triple 2s', meaning: 'Loner & Mood Swings' },
    '333': { type: 'negative', pair: '333', label: 'Triple 3s', meaning: 'Show off & Gossip.' },
    '444': { type: 'negative', pair: '444', label: 'Triple 4s', meaning: 'Should be avoided at all cost. Dangerous combination' },
    '555': { type: 'negative', pair: '555', label: 'Triple 5s', meaning: 'Needs fast results.' },
    '666': { type: 'negative', pair: '666', label: 'Triple 6s', meaning: 'Over Emotional if in personal number' },
    '777': { type: 'negative', pair: '777', label: 'Triple 7s', meaning: 'Wants to do self harm. Severe depression' },
    '888': { type: 'negative', pair: '888', label: 'Triple 8s', meaning: 'Self damaging thoughts, Downfall and losses' },
    '999': { type: 'negative', pair: '999', label: 'Triple 9s', meaning: 'argumentative, aggressiveness' },
};

// ── Numerology Total 1–9 Meaning ─────────────────────────────────────────────
export const MOBILE_TOTAL_MEANINGS = {
    1: { planet: 'Sun', meaning: 'Excellent for leadership, new beginnings, ambition, and career growth.' },
    2: { planet: 'Moon', meaning: 'Represents emotions, care, and sometimes mental fluctuation. Good for creative types.' },
    3: { planet: 'Jupiter', meaning: 'Represents expansion, management, knowledge, and ambition. Ideal for teachers, writers, and advisors.' },
    4: { planet: 'Rahu', meaning: 'Brings a restless, analytical mind. Best for scientists, researchers, or innovators.' },
    5: { planet: 'Mercury', meaning: 'Represents adaptability, curiosity, and business. Great for sales, communication, and fast-paced lives.' },
    6: { planet: 'Venus', meaning: 'Best for luxury, home-makers, luxury dealers, and creatives (music, art).' },
    7: { planet: 'Ketu', meaning: 'Strong, mystical number. Ideal for researchers, writers, and spiritual seekers, but may require higher efforts.' },
    8: { planet: 'Saturn', meaning: 'Attracts wealth but requires hard work and consistency. Good for business owners.' },
    9: { planet: 'Mars', meaning: 'Good for humanitarian, healing professions, and leaders. It brings fortune, but perhaps not for those seeking a calm, private life.' },
};

// ── Analysis Function ─────────────────────────────────────────────────────────
/**
 * Analyzes a mobile number and returns:
 * - found combinations (deduplicated) with type, pair, meaning
 * - total (digit sum reduced to 1–9) with planet & meaning
 */
export function analyzeMobileNumber(mobile) {
    const digits = String(mobile).replace(/\D/g, ''); // strip non-digits
    if (digits.length < 2) return { combinations: [], total: null, totalMeaning: null, digits: '' };

    const seenKeys = new Set();
    const combinations = [];

    // ── Pass 1: 3-digit repeated patterns (111, 222, …) — highest priority ────
    const tripleConsumed = new Set(); // track positions consumed by a triple match
    for (let i = 0; i < digits.length - 2; i++) {
        if (digits[i] === digits[i + 1] && digits[i + 1] === digits[i + 2]) {
            const triple = digits[i] + digits[i + 1] + digits[i + 2];
            const combo = MOBILE_COMBINATIONS[triple];
            if (combo && !seenKeys.has(triple)) {
                seenKeys.add(triple);
                combinations.push({ pair: triple, ...combo });
                tripleConsumed.add(i);
                tripleConsumed.add(i + 1);
                tripleConsumed.add(i + 2);
            }
        }
    }

    // ── Pass 2: consecutive 2-digit pairs (skip positions inside a triple) ────
    for (let i = 0; i < digits.length - 1; i++) {
        // Both positions inside a triple run → already represented; skip
        if (tripleConsumed.has(i) && tripleConsumed.has(i + 1)) continue;

        const pair = digits[i] + digits[i + 1];
        // For repeated-digit pairs (11, 22…) pair === reverse, so key is just pair
        const rev = digits[i + 1] + digits[i];
        const key = pair <= rev ? pair : rev;
        if (seenKeys.has(key)) continue;
        seenKeys.add(key);

        const combo = MOBILE_COMBINATIONS[pair];
        if (combo) {
            combinations.push({ pair, ...combo });
        }
    }

    // ── Pass 3: single-digit count warnings (4 and 8) ────────────────────────
    const digitCounts = {};
    for (const d of digits) digitCounts[d] = (digitCounts[d] || 0) + 1;

    if ((digitCounts['4'] || 0) >= 1 && !seenKeys.has('__4warn')) {
        seenKeys.add('__4warn');
        combinations.push({
            pair: '4',
            type: 'negative',
            label: 'Contains 4',
            meaning: 'Should be avoided in mobile number.',
        });
    }
    if ((digitCounts['8'] || 0) > 1 && !seenKeys.has('__8warn')) {
        seenKeys.add('__8warn');
        combinations.push({
            pair: '8',
            type: 'negative',
            label: 'Multiple 8s',
            meaning: 'Not more than one 8 is advised in a mobile number.',
        });
    }

    // Calculate total: sum all digits, reduce to 1–9
    let total = digits.split('').reduce((s, d) => s + parseInt(d), 0);
    while (total > 9) {
        total = String(total).split('').reduce((s, d) => s + parseInt(d), 0);
    }

    return {
        combinations,
        total,
        totalMeaning: MOBILE_TOTAL_MEANINGS[total] || null,
        digits,
    };
}
